import React from "react";
import validate from './validateLogin';
import useForm from './useLoginForm';
import './SignUpForm.css';
import { UserAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';


const LogInForm = ({ submitForm }) => {
  const { user } = UserAuth();
  const navigate = useNavigate();

  const { handleChange, handleSubmit, values, errors } = useForm(
    submitForm,
    validate
  );


  return(
    <div className="form-container">
      <img src="./images/L2.jpg" alt="Dog with Owner" className="img"/>
      <div className="form-content-right">
        <form onSubmit={handleSubmit} className='form' noValidate>
          <h1 className="title">
            Log In
          </h1>
          <span className='form-input-login'>
            Don't have an account already? <a href='/signup'>Sign-up here</a>
          </span>
          <div className='form-inputs'>
            <label className='form-label'>Email</label>
            <input
              className='form-input'
              type='email'
              name='email'
              placeholder='Enter your email'
              value={values.email}
              onChange={handleChange}
            />
            {errors.email && <p>{errors.email}</p>}
          </div>
          <div className='form-inputs'>
            <label className='form-label'>Password</label>
            <input
              className='form-input'
              type='password'
              name='password'
              placeholder='Enter your password'
              value={values.password}
              onChange={handleChange}
            />
            {errors.password && <p>{errors.password}</p>}
          </div>
          <button className='form-input-btn' type='submit'>
            Log In
          </button>
          <span className='form-input-login'>
            By continuing, you agree to accept our Privacy Policy and Terms of Service.
          </span>
        </form>
      </div>
    </div>
  )
}
export default LogInForm;